import { z } from 'zod'

export const UserId = z.uuid().brand<'UserId'>()
export type UserId = z.infer<typeof UserId>

export const HouseholdId = z.uuid().brand<'HouseholdId'>()
export type HouseholdId = z.infer<typeof HouseholdId>

export const SessionId = z.uuid().brand<'SessionId'>()
export type SessionId = z.infer<typeof SessionId>

export const TodoId = z.uuid().brand<'TodoId'>()
export type TodoId = z.infer<typeof TodoId>

export const RecipeId = z.uuid().brand<'RecipeId'>()
export type RecipeId = z.infer<typeof RecipeId>

export const ActivityId = z.uuid().brand<'ActivityId'>()
export type ActivityId = z.infer<typeof ActivityId>

export const GroceryId = z.uuid().brand<'GroceryId'>()
export type GroceryId = z.infer<typeof GroceryId>

export const newId = (): string => crypto.randomUUID()
